export const tagColors = [
  "bg-blue-600",
  "bg-green-600",
  "bg-orange-500",
  "bg-purple-600",
  "bg-red-600",
  "bg-yellow-400",
];
